import {
    Service
} from '../service.js'
import {
    env
} from '../env.js'

class TiposRelatorioProdutividadeService extends Service {
    constructor(controleDeInstancia) {
        super(controleDeInstancia);

        this.url = env.url + "tipos-relatorio-produtividade";
        
        this.controladoresDeInstancia = {
            listar: new AbortController()
        }
    }

    async listar(controlador) {
        this.controladoresDeInstancia.listar = this.selecionarControlador(controlador);
        return await super.get(this.url, this.controladoresDeInstancia.listar);
    }
}

export const tiposRelatorioProdutividadeService = new TiposRelatorioProdutividadeService()